import gql from 'graphql-tag';

/**
 * Fields of a project post ("Nachricht"), used by the post queries and mutations and by the block
 * project-posts.
 */
export const PROJECT_POST_FIELDS = gql`
  fragment projectPostFields on Post {
    id
    number
    content
    createdAt
    updatedAt
    user {
      id
      number
      firstname
      lastname
      email
      avatar {
        path
      }
    }
  }
`;
